import React, { forwardRef, Component } from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading,
  fullWidth,
  children,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-bold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wide';
  const variants = {
    primary: 'bg-red-600 hover:bg-red-700 text-white shadow-[0_0_20px_rgba(220,38,38,0.3)] hover:shadow-[0_0_30px_rgba(220,38,38,0.5)] border border-red-500',
    secondary: 'bg-neutral-800 hover:bg-neutral-700 text-white border border-neutral-700',
    outline: 'bg-transparent border-2 border-neutral-700 text-neutral-300 hover:border-neutral-500 hover:text-white'
  };
  const sizes = {
    sm: 'h-9 px-4 text-xs',
    md: 'h-11 px-6 text-sm',
    lg: 'h-14 px-8 text-base',
    xl: 'h-16 px-10 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  // Using motion.button for potential animations, but typing as regular button for now to keep it simple
  const Component = motion.button as any;
  return <Component ref={ref} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} disabled={isLoading || props.disabled} {...props} data-id="element-175">
        {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-176" />}
        {children}
      </Component>;
});
Button.displayName = 'Button';